/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { useState, useEffect } from 'react'
import { Flex, FormControl, useToast } from '@chakra-ui/react'
import { MdClose } from 'react-icons/md'
import Modal from 'react-modal'
import { ButtonCmp } from '../../../../../components/ButtonCmp'
import { InputCmp } from '../../../../../components/InputCmp'
import { SelectCmp } from '../../../../../components/SelectCmp'
import { WhiteModal } from './styles'
import { CheckboxCmp } from '../../../../../components/CheckboxCmp'
import { FaBriefcase, FaPlus } from 'react-icons/fa'
import { CriterioResponse, DescricaoCargo } from '../../../../../interfaces'
import { ElementoTooltipCmp } from '../../../../../components/ElementoTooltipCmp'
import { FindUser } from '../../../../../components/FindBox'
import { appApi } from '../../../../../services/appApi'
import { TextAreaCmp } from '../../../../../components/TextareaCmp'

export interface NivelCriterioInput {
  id?: string
  qtdUsos?: number
  nome: string
  pontuacao: number
}

export interface CriterioInput {
  nomeCriterio: string
  descricao: string
  tipo: number
  niveis: NivelCriterioInput[]
  nivelMinimo: boolean
  cargosEspecificos: boolean
  cargosId?: string[]
}

interface iModalProps {
  isOpen: boolean
  onCreate: (item: CriterioInput, update: boolean) => void
  onClose: () => void
  modelEdit?: CriterioResponse
}

interface CriterioInvalidFlags {
  NomeCriterioTrue: boolean
  TipoTrue: boolean
  NiveisVazioTrue: boolean
  NiveisAlgumInvalidoTrue: boolean
  CargosEspecificosSemCargosTrue: boolean
}

export const ModalCriterioCreate: React.FC<iModalProps> = ({
  isOpen,
  onClose,
  onCreate,
  modelEdit
}) => {
  const toast = useToast()
  const [Cargos, setCargos] = useState<DescricaoCargo[]>([])
  const [criterioInvalidFlags, setCriterioInvalidFlags] = useState<CriterioInvalidFlags>({
    NomeCriterioTrue: false,
    TipoTrue: false,
    NiveisVazioTrue: false,
    NiveisAlgumInvalidoTrue: false,
    CargosEspecificosSemCargosTrue: false
  })

  const [model, setModel] = useState<CriterioInput>({
    nomeCriterio: '',
    tipo: -1,
    niveis: [{ nome: '', pontuacao: 0 }],
    cargosEspecificos: false,
    cargosId: undefined,
    nivelMinimo: false,
    descricao: ''
  })

  const tipoOptions = [
    { label: 'Selecione um tipo', value: -1 },
    { label: 'Organizacional', value: 0 },
    { label: 'Liderança', value: 1 },
    { label: 'Técnica', value: 2 }
  ]

  function handleChange<K extends keyof CriterioInput>(
    field: K,
    value: any
  ): void {
    setModel((prev) => ({
      ...prev,
      [field]: value
    }))
  }

  function ValidateInput(input: CriterioInput): string {
    const next: CriterioInvalidFlags = { ...criterioInvalidFlags }
    let firstMessage: string | null = null

    const mark = (failed: boolean, key: keyof CriterioInvalidFlags, msg: string): void => {
      if (failed) {
        next[key] = true
        if (!firstMessage) firstMessage = msg
      } else {
        next[key] = false
      }
    }

    mark(!input.nomeCriterio || input.nomeCriterio.trim() === '',
      'NomeCriterioTrue',
      'Preencha o nome do critério'
    )

    mark(input.tipo === -1,
      'TipoTrue',
      'Selecione um tipo para seu critério'
    )

    const niveisVazio = !Array.isArray(input.niveis) || input.niveis.length === 0
    mark(niveisVazio,
      'NiveisVazioTrue',
      'Preencha esse critério com pelo menos um nível'
    )

    let niveisAlgumInvalido = false
    if (!niveisVazio) {
      niveisAlgumInvalido = input.niveis.some(n =>
        !n?.nome ||
        n.nome.trim() === '' ||
        n.pontuacao === null ||
        n.pontuacao === undefined ||
        Number.isNaN(Number(n.pontuacao)) ||
        Number(n.pontuacao) < 0
      )
    }
    mark(niveisAlgumInvalido,
      'NiveisAlgumInvalidoTrue',
      'Níveis do critério inválido(s): A pontuação deve ser maior ou igual á zero e o nome deve conter ao menos um caractere'
    )

    const cargosEspecificosSemCargos =
      !!input.cargosEspecificos &&
      (!Array.isArray(input.cargosId) ||
      input.cargosId.filter(e => e !== '' && e.length === 36).length === 0)

    mark(cargosEspecificosSemCargos,
      'CargosEspecificosSemCargosTrue',
      'Coloque pelo menos um cargo na lista de cargos exclusivos deste critério ou desative a opção'
    )

    setCriterioInvalidFlags(next)

    return firstMessage ?? ''
  }

  function handleCreate(): void {
    const validate = ValidateInput(model)
    if (validate !== '') {
      toast({
        title: validate,
        duration: 4000,
        position: 'top',
        status: 'error'
      })

      return
    }

    onCreate({ ...model, cargosId: model.cargosId?.filter(e => e !== '' && e.length === 36) }, !!modelEdit)
  }

  function GetDescritivos(): void {
    appApi.get('api/CargosESalarios')
      .then((res) => {
        setCargos(res.data)
      })
      .catch(err => console.log(err))
  }

  useEffect(() => {
    if (modelEdit) {
      setModel({
        niveis: modelEdit.niveis,
        nomeCriterio: modelEdit.nomeCriterio,
        tipo: modelEdit.tipo,
        nivelMinimo: modelEdit.nivelMinimo,
        cargosEspecificos: modelEdit.cargosEspecificos,
        cargosId: modelEdit.cargosId,
        descricao: modelEdit.descricao
      })
    } else {
      setModel({
        nomeCriterio: '',
        tipo: -1,
        niveis: [{ nome: '', pontuacao: 0 }],
        nivelMinimo: false,
        cargosEspecificos: false,
        cargosId: undefined,
        descricao: ''
      })
    }

    if (Cargos.length === 0) {
      GetDescritivos()
    }

    if (!isOpen) {
      setCriterioInvalidFlags({
        NomeCriterioTrue: false,
        TipoTrue: false,
        NiveisVazioTrue: false,
        NiveisAlgumInvalidoTrue: false,
        CargosEspecificosSemCargosTrue: false
      })
    }
  }, [isOpen])

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      overlayClassName="react-modal-overlay"
      className="react-modal-content-default"
    >
      <WhiteModal style={{ width: '60rem' }}>
        <FormControl as={Flex} flexDir="column" gap="1rem">
          <Flex justifyContent="space-between">
            <h3
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
                color: 'var(--Azul)'
              }}
            >
              {modelEdit ? 'Editar critério' : 'Novo critério'}
            </h3>
            <Flex color="var(--Red)" _hover={{ color: 'var(--Red-hover)' }}>
              <MdClose cursor="pointer" size={18} onClick={onClose} />
            </Flex>
          </Flex>

          <Flex flexDir="column" gap="1rem">
            <InputCmp
              label="Nome do critério*"
              value={model.nomeCriterio}
              isInvalid={criterioInvalidFlags.NomeCriterioTrue}
              placeholder="Digite o nome do critério..."
              OnChange={(v) => handleChange('nomeCriterio', v)}
            />

            <TextAreaCmp
              label="Descrição"
              value={model.descricao}
              placeholder="Digite o descrição do critério..."
              OnChange={(v) => handleChange('descricao', v)}
            />

            <SelectCmp
              w="100%"
              title="Tipo*"
              placeholder="Selecione o tipo..."
              isInvalid={criterioInvalidFlags.TipoTrue}
              value={model.tipo.toString()}
              OnChange={(v) => handleChange('tipo', parseInt(v))}
            >
              {tipoOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </SelectCmp>

            <CheckboxCmp
              isChecked={model.nivelMinimo}
              OnChange={(val) => {
                setModel({ ...model, nivelMinimo: val })
              }}
            >Selecione para adicionar nível desejável e mínimo</CheckboxCmp>

            <Flex flexDir="column" gap="0.5rem">
              <strong>Níveis do critério</strong>
              {model.niveis.map((nivel, idx) => (
                <Flex key={idx} gap="0.5rem" align="center">
                  <InputCmp
                    label={idx === 0 ? 'Nome' : undefined}
                    placeholder="Nome do nível..."
                    value={nivel.nome}
                    isInvalid={(criterioInvalidFlags.NiveisAlgumInvalidoTrue || criterioInvalidFlags.NiveisVazioTrue) && nivel.nome === ''}
                    w={'100%'}
                    OnChange={(v) => {
                      const novos = [...model.niveis]
                      novos[idx].nome = v
                      handleChange('niveis', novos)
                    }}
                  />
                  <InputCmp
                    label={idx === 0 ? 'Pontuação' : undefined}
                    placeholder="0"
                    w={'15%'}
                    type="number"
                    min={0}
                    value={nivel.pontuacao.toString()}
                    isInvalid={(criterioInvalidFlags.NiveisAlgumInvalidoTrue || criterioInvalidFlags.NiveisVazioTrue) && nivel.pontuacao < 0}
                    OnChange={(v) => {
                      const novos = [...model.niveis]
                      novos[idx].pontuacao = Number(v)
                      handleChange('niveis', novos)
                    }}
                  />
                  {(!nivel.qtdUsos || nivel.qtdUsos === 0) && <Flex onClick={() => {
                    const novos = [...model.niveis]
                    novos.splice(idx, 1)
                    handleChange('niveis', novos)
                  }} pt={idx === 0 ? '25px' : undefined}
                    color={'var(--Red)'} cursor={'pointer'} _hover={{ color: 'var(--Red-hover)' }}>
                    <ElementoTooltipCmp bg={'var(--Red)'} label={'Remover nível do critério'}>
                      <MdClose />
                    </ElementoTooltipCmp>
                  </Flex>}
                  {!(!nivel.qtdUsos || nivel.qtdUsos === 0) && <Flex pt={idx === 0 ? '25px' : undefined}
                    color={'var(--Red)'} cursor={'not-allowed'} opacity={'.5'}>
                    <ElementoTooltipCmp bg={'var(--Red)'} label={'Você não pode remover esse nível pois ele já está associado à algum cargo do sistema'}>
                      <MdClose />
                    </ElementoTooltipCmp>
                  </Flex>}
                </Flex>
              ))}
              <ButtonCmp
                OutlineColor="Green2"
                leftIcon={<FaPlus />}
                w="14rem"
                onClick={() =>
                  handleChange('niveis', [...model.niveis, { nome: '', pontuacao: 0 }])
                }
              >
                Adicionar nível
              </ButtonCmp>
            </Flex>

            <CheckboxCmp isChecked={model.cargosEspecificos} OnChange={(val) => { setModel({ ...model, cargosEspecificos: val, cargosId: (val && (!model.cargosId || model.cargosId?.length === 0)) ? [''] : model.cargosId }) }}>Habilitar critério apenas para cargos específicos</CheckboxCmp>

            {model.cargosEspecificos && <Flex flexDir={'column'} gap={'.5rem'}>
              <strong>Cargos específicos</strong>
              {model.cargosId?.map((c, idx) => {
                return <Flex gap="0.5rem" align="center">
                  <FindUser
                    lista={Cargos.map(e => { return { id: e.id, nome: e.nomeCargo } })}
                    onChoice={(val) => {
                      const novos = [...model.cargosId ?? []]
                      novos[idx] = val
                      handleChange('cargosId', novos)
                    }}
                    placeholder='Busque o cargo pelo nome'
                    isNotUser
                    leftIcon={<FaBriefcase size={'1.3rem'} />}
                    isInvalid={(criterioInvalidFlags.CargosEspecificosSemCargosTrue) && c === ''}
                    selecionado={c}
                  />
                  {(model.cargosId && model.cargosId?.length > 1) && <Flex onClick={() => {
                    const novos = [...model.cargosId ?? []]
                    novos.splice(idx, 1)
                    handleChange('cargosId', novos)
                  }}
                    color={'var(--Red)'} cursor={'pointer'} _hover={{ color: 'var(--Red-hover)' }}>
                    <ElementoTooltipCmp bg={'var(--Red)'} label={'Remover cargo'}>
                      <MdClose />
                    </ElementoTooltipCmp>
                  </Flex>}
                </Flex>
              })}
              <ButtonCmp
                OutlineColor="Green2"
                leftIcon={<FaPlus />}
                w="14rem"
                onClick={() =>
                  handleChange('cargosId', [...model.cargosId ?? [], ''])
                }
              >
                Adicionar cargo
              </ButtonCmp>
            </Flex>}
          </Flex>
        </FormControl>

        <Flex justifyContent="end" gap=".375rem" mt="1rem">
          <ButtonCmp VarColor="c6" onClick={onClose}>
            Cancelar
          </ButtonCmp>
          <ButtonCmp VarColor="Green2" onClick={handleCreate}>
            {modelEdit ? 'Salvar alterações' : 'Criar critério'}
          </ButtonCmp>
        </Flex>
      </WhiteModal>
    </Modal>
  )
}
